(function () {
	'use strict';

	angular
		.module('app.setup')
		.service('leanSyncConfigService', leanSyncConfigService);

	leanSyncConfigService.$inject = ['$http', '$rootScope'];

	function leanSyncConfigService($http, $rootScope) {
		var service = {
			getTables: getTables,
			getTableConfig: getTableConfig,
			saveMappingsForTable: saveMappingsForTable,
			saveLeanSyncField: saveLeanSyncField,
			uploadLeanSyncFile: uploadLeanSyncFile
		};
		return service;

		function getTables(siteId) {
			return $http.get('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/LeanSyncTables')
				.then(getTablesSuccess, handleError);

			function getTablesSuccess(response) {
				return response.data;
			}
		}

		function getTableConfig(tableNdx, siteId) {
			return $http.get('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/LeanSyncTable/' + tableNdx + '/Config')
				.then(getTableConfigSuccess, handleError);

			function getTableConfigSuccess(response) {
				var lastModified = response.headers()['last-modified'];
				return {
					data: response.data,
					lastModified: lastModified
				};
			}
		}

		function saveMappingsForTable(tableNdx, table, lastModified, siteId) {
			return $http.put('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/LeanSyncTable/' + tableNdx, table, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			}).then(saveMappingsForTableSuccess, handleError);

			function saveMappingsForTableSuccess(response) {
				$rootScope.$emit('toast', {
					'message': 'Mappings Saved',
					'success': true
				});
				return response.data;
			}
		}

		function saveLeanSyncField(leanSyncField, siteId) {
			return $http.post('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/LeanSyncField',leanSyncField ).then(saveLeanSyncFieldSuccess, handleError);

			function saveLeanSyncFieldSuccess(response) {
				$rootScope.$emit('toast', {
					'message': 'Lean Sync Field Saved',
					'success': true
				});
				return 'Lean Sync Field Added Successfully';
			}
		}

		function uploadLeanSyncFile(leanSyncUpload, uploadTypeMessage, siteId) {
			var fd = new FormData();
			fd.append('file', leanSyncUpload.file);
			fd.append('uploadType', leanSyncUpload.uploadType);

			return $http.post('/api/2/factndx/' + (siteId || globalConfig.factory.id) + '/LeanSync/FileUpload', fd, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined,
					'isFileUpload': true

				}
			}).then(uploadLeanSyncFileSuccess, handleUploadError);

			function uploadLeanSyncFileSuccess(response) {
				$rootScope.$emit('toast', {
					'message': uploadTypeMessage + ' file uploaded successfully',
					'success': true
				});
				return 'Lean Sync File Uploaded Successfully';
			}
		}

		function handleUploadError(error) {
			if (error.status === 403) {
				$rootScope.$emit('toast', {
					'message': 'Request failed, you do not have the permissions required for the requested action',
					'success': false
				});
				return 'Request failed, you do not have the permissions required for the requested action';
			}
			var msg = error.data;
			if (!msg) {
				msg = 'Unknown failure reason';
			}
			$rootScope.$emit('toast', {
				'message': 'Upload failed: ' + msg,
				'success': false 
			});
			return msg;
		}

		function handleError(error) {
			if (error.status === 403) {
				$rootScope.$emit('toast', {
					'message': 'Request failed, you do not have the permissions required for the requested action',
					'success': false
				});
				return 'Request failed, you do not have the permissions required for the requested action';
			} else if (error.status === 412) {
				$rootScope.$emit('toast', {
					'message': 'Error Saving Mappings',
					'success': false
				});
				return error.data.error;
			}
			$rootScope.$emit('toast', {
				'message': 'Error Saving Mappings',
				'success': false
			});
			return 'Unknown server error';
		}
	}
})();
